<h1 mat-dialog-title>
    <span>{{ tolerance.libelle }}</span>
    <span type="button" (click)="closeDialog()"><i class="zmdi zmdi-close"></i></span>
</h1>
<form>
    <div class="content">
        <mat-dialog-content *ngIf="tolerance">
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="tolerancePourcentage"
                        name="tolerancePourcentage"
                        customType="number"
                        [(ngModel)]="tolerancePourcentage"
                        libelle="admin.frais.tolerances.infos.tolerancePourcentage"
                        [min]="0"
                        [nbDecimales]="2"
                        [lCol]="4"
                        [suffix]="'%'">
                </custom-input>
            </div>
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="toleranceMontant"
                        name="toleranceMontant"
                        customType="number"
                        [(ngModel)]="tolerance.toleranceMontant"
                        libelle="admin.frais.tolerances.infos.toleranceMontant"
                        [min]="0"
                        [nbDecimales]="2"
                        [lCol]="4"
                        [suffix]="'EUR'">
                </custom-input>
            </div>
            <div class="row">
                <custom-input ngDefaultControl
                              id="active"
                              name="active"
                              [ngModel]="tolerance.active"
                              [(customModel)]="tolerance.active"
                              customType="checkbox"
                              [lCol]="4"
                              libelle="admin.frais.tolerances.infos.actif">
                </custom-input>
            </div>
        </mat-dialog-content>
    </div>
    <div mat-dialog-actions>
        <button mat-flat-button color="primary" (click)="onSave()"><span [translate]="'global.actions.enregistrer'"></span></button>
    </div>
</form>
